

  
const content = `# MongoDB Encryption Limitations
There are multiple limitations when using the OnData Encryption Tool (version 2) to process MongoDB databases. None of these scenarios are common, but they are documented here 
just in case some of them are used.  
  
1. A data field in an object cannot be multiple data types. For example, the \`test\` data field below cannot be both an integer type and a string type. The schema only 
backup will fail in this scenario.   
\`\`\`json
[{
  "_id": {
    "$oid": "673c32b1b56ad6b35e1401c9"
  },
  "object": {
    "object1": {
      "test": 1,
      "check": "type"
    },
    "object2": {
      "test": "5",
      "check": "name"
    }
  }
}]
\`\`\`

2. Cannot encrypt GeoJSON objects or Geospatial indexes. Please do not configure encryption rules for GeoJSON type or Geospatial coordinates.  
  
3. Cannot encrypt time series collection. Please do not configure encryption rules for time series collections. Otherwise, such rules won't be used or effective.  
  
4. Do not set encryption rules on data fields that are used by TTL indexes. TTL indexes are special single-field indexes that MongoDB can use to automatically 
remove documents from a collection after a certain amount of time or at a specific clock time. Encrypting fields used by TTL indexes could cause unintended data losses.  
  
5. Similar to relational databases, the validation rules on data fields may prevent the encryption of those data fields, because the encrypted data may not pass the 
validation rules. If you choose to encrypt a data field, you may remove the validation rules associated with that data field.  
  
6. If certain data field has a text index, please do not set any encryption rule on the \`language\` field of the index, which is used to include translations 
for the text in different languages.  
  
7. Under certain circumstances, the data type may change after encryption or decryption
    * For the Int64 data type, if the data value is in the range of Int32 and gets encrypted, the data type will be automatically changed to Int32 after decryption.
    * If a number contains more than 15 digits or uses scientific notation, the data type of the number may change to String.  
  
8. When obfuscating (instead of encrypting) data inside MongoDB, the "Clear Data" obfuscation rule cannot be used for certain types of data fields because they cannot 
be set to NULL. Such data types include \`Date\`, \`MinKey\`, \`MaxKey\`, \`BSONRegExp\`, \`Code\`, \`dbref -$id -$oid sub-field\`, and \`Decimal128\`.  
  
9. When determining the encryption rules to be used, the search for collection names and column names are case insensitive
    * If two collections with the same name but different capitalization, the encryption rules configured for the first collection found will be used.
    * If two columns with the same collection have the same name but different capitalization, the encryption rule configured for the first column found will be used.

10. The Decimal128 data type has an exponent range of -6143 to +6144. If the exponent has 4 digits, the encrypted value range can go from -9999 to 9999, which is 
larger than the allowed range. When the exponent is outside the supported range, the encrypted value cannot be inserted back to the MongoDB database.
  `
  
export default content;
